import React from 'react';

interface PendingActionItemProps {
  icon: React.ReactNode;
  iconBgColor: string;
  title: string;
  description: string;
}

const PendingActionItem: React.FC<PendingActionItemProps> = ({
  icon,
  iconBgColor,
  title,
  description,
}) => {
  return (
    <div className="flex items-center justify-between rounded-xl border border-[#F2F4F7] bg-gray-50 p-5 hover:bg-gray-100 transition-colors cursor-pointer">
      <div className="flex items-center gap-4">
        <div className={`rounded-full ${iconBgColor} p-2.5`}>{icon}</div>
        <div>
          <p className="font-semibold text-gray-900">{title}</p>
          <p className="text-sm text-gray-500 mt-1">{description}</p>
        </div>
      </div>
      <svg
        className="h-5 w-5 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    </div>
  );
};

export default PendingActionItem;
